module.exports = __webpack_public_path__ + "media/images/research-c3a0beba5c76b8c30dd90d5e313dc66f.png";